/**
 * 认证相关 API（登录/注册/找回密码）
 */
import { post, get, upload } from '@/utils/request'

/** 用户登录 */
export const customerLogin = (data) => post('cmsLogin/customerLogin', data)

/** 用户退出登录（token 由请求拦截器自动放到 header） */
export const customerLogout = () => get('cmsLogin/customerLogout')

/** 用户注册 */
export const registerUser = (data) => post('cmsLogin/registerUser', data)

/** 验证用户名是否已存在 */
export const verificationUserName = (data) => post('cmsLogin/verificationUserName', data)

/** 验证手机号是否已存在 */
export const verificationMobile = (data) => post('cmsLogin/verificationMobile', data)

/** 获取课题组列表（院内注册） */
export const findTeamList = () => post('cmsCustomer/findTeamList')

/** 上传公司资质文件 */
export const registerCompFile = (formData) => upload('/cmsCustomer/registerCompFile', formData)

/** 发送注册邮箱验证码 */
export const sendRegisterEmailCode = (data) => post('cmsLogin/sendRegisterEmailCode', data)

/** 发送找回密码邮箱验证码 */
export const sendFindEmailCode = (data) => post('cmsLogin/sendFindEmailCode', data)

/** 重置密码 */
export const updatePassword = (data) => post('cmsLogin/updatePassword', data)
